import { type ReactElement } from 'react';
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from '@/Components/ui/tooltip';
import { Info } from 'lucide-react';
import { cn } from '@/lib/utils';

interface InfoTooltipProps {
    content: string;
    side?: 'top' | 'right' | 'bottom' | 'left';
    className?: string;
}

export function InfoTooltip({ content, side = 'top', className }: InfoTooltipProps): ReactElement {
    return (
        <TooltipProvider delayDuration={200}>
            <Tooltip>
                <TooltipTrigger asChild>
                    <Info className={cn("h-3 w-3 text-muted-foreground/50 cursor-help", className)} />
                </TooltipTrigger>
                <TooltipContent side={side} className="max-w-xs text-xs">
                    {content}
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
}
